import { SELECCIONAR_NUMCOMPROBANTE, SELECCIONAR_NUMCOMPROBANTEALTERNO } from '../actions/generales/actionTypes';

const estadoInicial =  { numComprobSel: '', numComprobAlternoSel: '' };

const generalesReducer = (state=estadoInicial, action) => {
    switch(action.type){
        case SELECCIONAR_NUMCOMPROBANTE:
            return {...state, numComprobSel: action.numeroComprobante};
        case SELECCIONAR_NUMCOMPROBANTEALTERNO:
            return {...state, numComprobAlternoSel: action.numeroComprobanteAlt};
        default:
            return state;
    }
};

export default generalesReducer;